import React from "react";
import { Api_EndPoints } from "../../utils/Api_EndPoints";
import { useMutation } from "@tanstack/react-query";
import http_payroll from "../../utils/http_payroll";

const updateDesignation = async (input) => {
  const data = await http_payroll.put(
    Api_EndPoints.UpdateDesignation,
    input
  );
  
  console.log(data)
  return data;
};

export const useUpdateDesignationMutation = () => {
  return useMutation({
    mutationFn: updateDesignation,
  });
};
